import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { accountDataState } from 'components/account/account.state';
import { ActionMenuItemConfig } from 'components/search/SearchActionsDropdown';
import ELEMENT, { createTestId } from 'common/element';
import { completeFilterState } from 'components/common/Managers/RouteStateManager.state';
import { EventAction } from '../../../types';
import EventActionsExecutor from './EventActionsExecutor';
import { saveAsRuleAction } from './actions';

export const CreateSTARRuleButton = () => {
  const [selectedAction, setSelectedAction] = useState<EventAction | null>(null);
  const completeFilter = useRecoilValue(completeFilterState);

  const accountData = useRecoilValue(accountDataState);
  const { S1ConsoleURL } = accountData;

  const handleClick = () => {
    setSelectedAction(saveAsRuleAction);
  };

  return (
    <div onClick={handleClick}>
      Create STAR Rule
      <EventActionsExecutor
        action={selectedAction}
        values={{ query: completeFilter, 'origin.mgmt.url': S1ConsoleURL }}
        actionCompleteCallback={() => {
          setSelectedAction(null);
        }}
      />
    </div>
  );
};

export const CreateStarRuleMenuItem: ActionMenuItemConfig = {
  text: 'Create STAR rule',
  clickHandler: () => {},
  testId: createTestId(ELEMENT.searchLogsCreateRule),
  children: <CreateSTARRuleButton />,
};
